import React, { useContext } from 'react'
import LineItem from './LineItem'
import { StoreContext } from '@context/StoreContext'
import { productFormattedPrice } from "@utils"
import clsx from 'clsx'

const BagContents = () => {
    const {checkout} = useContext(StoreContext);

    const amountForFreeShipping = 100 - parseInt(checkout?.cost?.subtotalAmount?.amount);
    const percentageForFreeShipping = Math.min((parseFloat(checkout?.cost?.subtotalAmount?.amount) / 100) * 100, 100);

    const formatAmountRequiredForFreeShipping = (amount) => {
        return checkout?.cost?.subtotalAmount?.amount ?
                    productFormattedPrice(
                        checkout?.cost?.totalAmount?.currencyCode,
                        amount
                    )
                    : null
    }
    
    return (
        <React.Fragment>
            <section className="">
                <div className="p-4 space-y-2">
                    {
                        amountForFreeShipping > 0 ? <p>YOU ARE <b>{formatAmountRequiredForFreeShipping(amountForFreeShipping)}</b> away from free express shipping!</p> : <p>You got it! Checkout now for <b>FREE express</b> shipping.</p>
                    }
                    <div className="w-full rounded-full bg-[#D1D1D1]">
                        <div className='h-1.5 rounded-full bg-gray-700 before:content-[""]' style={{ width: `${percentageForFreeShipping}%` }} />
                    </div>
                </div>

                <div className='sticky left-0 w-full border-t border-gray-300 h-1' />

                <section className="p-4 space-y-4">
                    {
                        /*
                            <div className="flex flex-nowrap justify-between text-xs pb-4">
                                <div className="space-x-2">
                                    <span className="text-tertiary">Estimated Delivery</span>
                                    <span className='font-semibold'>May 20 - May 29</span>
                                </div>
                                <div className='inline-flex gap-2 items-center'>
                                    <Heart size={16} weight={`light`} />
                                    SAVE ALL
                                </div>
                            </div>
                        */                        
                    }
                    

                    <div className="space-y-6">
                        {checkout?.lines?.edges?.map((item, index) => {
							const isLastItem = checkout?.lines?.edges?.length === (index + 1)
							// console.info('lastItem:', isLastItem)
							return (
								<div key={`line-item-${item?.id}-${index}`} className={clsx('py-4', isLastItem && 'ios-only:more-mb')}>
									<LineItem item={item?.node} />
								</div>
							)
                        })}
                    </div>
                </section>
            </section>
        </React.Fragment>
    );
}

export default BagContents